<div class="d-flex flex-column h-100">
  <div class="header">
    <app-header></app-header>
  </div>
  <div class="main-panel h-100">
    <app-sidebar></app-sidebar>
    <div class="content" [@routeAnimations]="prepareRoute(outlet)">
      <router-outlet #outlet="outlet"></router-outlet>
    </div>
  </div>
</div>
